import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ToastProvider } from "@/components/dash/Toast";
import Dashboard from "@/views/Dashboard";
import Login from "@/views/Login";
import AdminLayout from "@/views/admin/AdminLayout";
import { ADMIN_ITEMS, adminItemFor } from "@/views/admin/items";

const toLogin = () => {
  if (window.location.pathname !== "/login") {
    try { sessionStorage.setItem("hdfc-next", window.location.pathname + window.location.hash); } catch (e) { }
    window.history.replaceState(null, "", "/login");
  }
};
const toApp = () => {
  let next = "/";
  try { next = sessionStorage.getItem("hdfc-next") || "/"; sessionStorage.removeItem("hdfc-next"); } catch (e) { }
  window.history.replaceState(null, "", next.startsWith("/") ? next : "/" + next);
};

export default function App() {
  const [user, setUser] = useState(undefined);
  const [path, setPath] = useState(window.location.pathname);
  const sync = useCallback(() => setPath(window.location.pathname), []);
  const nav = useCallback(to => { window.history.pushState(null, "", to); sync(); }, [sync]);
  useEffect(() => {
    api("/api/auth/me").then(r => r.ok ? r.json() : null).then(setUser).catch(() => setUser(null));
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, [sync]);
  useEffect(() => {
    if (user === null) toLogin();
    else if (user && window.location.pathname === "/login") toApp();
    sync();
  }, [user, sync]);
  useEffect(() => {
    if (!user || !path.startsWith("/admin")) return;
    if (!user.is_admin) window.history.replaceState(null, "", "/");
    else if (!adminItemFor(path)) window.history.replaceState(null, "", ADMIN_ITEMS[0].path);
    else return;
    sync();
  }, [user, path, sync]);
  const onExpired = useCallback(() => setUser(null), []);
  const onLogout = useCallback(async () => {
    try { await api("/api/auth/logout", { method: "POST" }); } catch (e) { }
    setUser(null);
  }, []);
  const onLogin = useCallback(u => { toApp(); setUser(u); }, []);

  if (user === undefined) return null;
  const adminItem = user && user.is_admin ? adminItemFor(path) : null;
  if (user && path.startsWith("/admin") && !adminItem) return null;
  return (
    <ToastProvider>
      {!user ? <Login onDone={onLogin} />
        : adminItem ? <AdminLayout key={adminItem.id} item={adminItem} user={user} onLogout={onLogout} onExpired={onExpired} onNav={nav} />
          : <Dashboard key={path} user={user} onLogout={onLogout} onExpired={onExpired} onNav={nav} />}
    </ToastProvider>
  );
}
